import i18n from "i18next";
import Backend from "i18next-http-backend";

i18n.use(Backend).init({
  // detection: { order: ['en'] },
  backend: {
    loadPath: `/locales/{{lng}}/{{ns}}.json?v=${encodeURI(import.meta.env.PACKAGE_VERSION)}`,
  },
  react: {
    useSuspense: false,
    // wait: true, // globally set to wait for loaded translations in translate hoc
  },
  supportedLngs: ["en"],
  lng: "en",
  // ns: ['translation'],
  defaultNS: "translation",
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
  },
});

export default i18n;
